module.exports = {
    SINGULAR: {
        MM: '',
        D: 'DAY',
        h: 'HRS',
        m: 'MIN',
        s: 'SEC'
    },
    PLURAL: {
        MM: '',
        D: 'DAYS',
        h: 'HRS',
        m: 'MINS',
        s: 'SECS'
    }
};



// WEBPACK FOOTER //
// ./app/scripts/constants/_countdown.js